import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Login from './views/Login'
import Logout from './views/Logout'

import Profile from './views/profile/Profile'

import Users from './views/users/Users'
import UsersView from './views/users/UsersView'
import UsersAdd from './views/users/UsersAdd'
import UsersEdit from './views/users/UsersEdit'

import Lots from './views/lots/Lots'
import LotsAdd from './views/lots/LotsAdd'
import LotsView from './views/lots/LotsView'
import LotsEdit from './views/lots/LotsEdit'

import Stages from './views/stages/Stages'
import StagesAdd from './views/stages/StagesAdd'
import StagesView from './views/stages/StagesView'
import StagesEdit from './views/stages/StagesEdit'

import Tasks from './views/tasks/Tasks'
import TasksAdd from './views/tasks/TasksAdd'
import TasksView from './views/tasks/TasksView'
import TasksEdit from './views/tasks/TasksEdit'

import Houses from './views/houses/Houses'
import HousesView from './views/houses/HousesView'
import HousesAdd from './views/houses/HousesAdd'
import HousesEdit from './views/houses/HousesEdit'

import ClientsView from './views/clients/Clients'

import Test from './views/test/Test'

// const Login = () => import('./views/Login');
// const Logout = () => import('./views/Logout');
// const Home = () => import('./views/Home');
// const Posts = () => import('./views/Posts');

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // {path: '/', component: Houses, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/login', component: Login, meta: {requiresAuth: false}},
        {path: '/logout', component: Logout, meta: {requiresAuth: false}},

        {path: '/usuarios', component: Users, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/usuarios/nuevo', component: UsersAdd, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/usuarios/:id', component: UsersView, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/usuarios/editar/:id', component: UsersEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/lotes', component: Lots, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/lotes/nuevo', component: LotsAdd, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/lotes/:id', component: LotsView, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/lotes/editar/:id', component: LotsEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/etapas', component: Stages, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/etapas/nuevo', component: StagesAdd, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/etapas/:id', component: StagesView, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/etapas/editar/:id', component: StagesEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/tareas', component: Tasks, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/tareas/nuevo', component: TasksAdd, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/tareas/:id', component: TasksView, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/tareas/editar/:id', component: TasksEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/casas', component: Houses, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/casas/nuevo', component: HousesAdd, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/casas/:id', component: HousesView, meta: {requiresAuth: true, roles: ['administrator']}},
        {path: '/casas/editar/:id', component: HousesEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/perfil', component: Profile, meta: {requiresAuth: true, roles: ['administrator', 'subscriber']}},

        {path: '/perfil/:id', component: UsersEdit, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '/clientes', component: ClientsView, meta: {requiresAuth: true, roles: ['subscriber']}},

        {path: '/test', component: Test, meta: {requiresAuth: true, roles: ['administrator']}},

        {path: '*', redirect: '/casas', meta: {requiresAuth: true, roles: ['administrator']}}
    ]
});


router.beforeEach((to, from, next) => {
    const authRequired = to.meta.requiresAuth;
    const LoggedIn = store.state.login.isLoggedIn;
    const roleRequired = to.meta.roles || null;
    const LoggedRole = store.state.login.user.role || null;

    if (to.path === '/login' && LoggedIn) {
        return next('/');
    }

    if (authRequired && !LoggedIn) {
        return next('/login');
    }

    if (null !== roleRequired) {
        if (roleRequired.includes(LoggedRole) === false) {
            return next('/logout');
        }
    }

    next();
});